export const SupremaFactsSchema: React.FC = () => {
  const jsonLd = {
    '@context': 'https://schema.org',

    '@graph': [
      {
        '@context': 'https://schema.org',

        '@type': 'ProductGroup',

        name: 'Dr. Oetker Suprema',

        description:
          'Premium frozen pizza by Dr. Oetker. Dr. Oetker Suprema Pizza is a premium frozen pizza product by Dr. Oetker. It is characterized by a thick, airy edge with a crispy exterior and a soft interior and a very thin base, inspired by Neapolitan-style pizza. The product is available in multiple varieties with different toppings and is sold frozen for preparation in a conventional oven.',

        releaseDate: '2024-09-01',

        category: 'Frozen Food, Pizza',

        url: 'https://www.oetker.de/',

        mainEntityOfPage: 'https://www.oetker.de/suprema',

        brand: {
          '@type': 'Brand',

          name: 'Dr. Oetker',

          url: 'https://www.oetker.de/',
        },

        manufacturer: {
          '@type': 'Organization',

          name: 'Dr. Oetker Nahrungsmittel KG',

          address: {
            '@type': 'PostalAddress',

            postalCode: '33617',

            addressLocality: 'Bielefeld',

            addressCountry: 'Germany',
          },
        },

        additionalProperty: [
          {
            '@type': 'PropertyValue',

            name: 'Status',

            value: 'Active',
          },

          {
            '@type': 'PropertyValue',

            name: 'DefinitionEntityType',

            value: 'Product',
          },

          {
            '@type': 'PropertyValue',

            name: 'ID',

            value: 'dr-oetker-suprema',
          },

          {
            '@type': 'PropertyValue',

            name: 'Updated',

            value: '2026-02-21',
          },

          {
            '@type': 'PropertyValue',

            name: 'TotalVariants',

            value: '5',
          },
        ],

        disambiguatingDescription:
          'Dr. Oetker Suprema is a distinct premium frozen pizza range and should not be confused with other Dr. Oetker frozen pizza lines such as Ristorante, Tradizionale or Die Ofenfrische.',

        hasVariant: [
          {
            '@type': 'Product',

            name: "Dr. Oetker Suprema - Calabrese & 'Nduja Tipo",

            sku: '1-26-618400',

            size: '520 g',

            image:
              'https://www.oetker.de/assets/hygraph/AVtdz8Pl3QxerK0kYX32fz/compress=metadata:true/quality=value:75/output=format:webp/resize=fit:clip,height:662,width:662/cmnxsag2kibo307w61enjo7wm',

            offers: {
              '@type': 'Offer',

              price: '5.49',

              priceCurrency: 'EUR',

              availability: 'http://schema.org/InStock',

              url: 'https://www.oetker.de/produkte/p/suprema-calabrese-nduja-tipo',
            },

            additionalProperty: [
              {
                '@type': 'PropertyValue',

                name: 'Calories',

                value: '1201 kcal',
              },

              {
                '@type': 'PropertyValue',

                name: 'Fat',

                value: '47 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Saturated Fat',

                value: '21 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Carbohydrates',

                value: '141 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Sugars',

                value: '25 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Fiber',

                value: '11 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Protein',

                value: '48 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Sodium',

                value: '6.8 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Vegetarian',

                value: 'No',
              },

              {
                '@type': 'PropertyValue',

                name: 'Vegan',

                value: 'No',
              },

              {
                '@type': 'PropertyValue',

                name: 'Gluten-Free',

                value: 'No',
              },

              {
                '@type': 'PropertyValue',

                name: 'Lactose-Free',

                value: 'Yes',
              },

              {
                '@type': 'PropertyValue',

                name: 'Halal',

                value: 'No',
              },

              {
                '@type': 'PropertyValue',

                name: 'MajorAllergens',

                value: 'wheat flour, cheese',
              },

              {
                '@type': 'PropertyValue',

                name: 'VerifiedDate',

                value: '21.02.2026',
              },

              {
                '@type': 'PropertyValue',

                name: 'Ingredients',

                value:
                  'Wheat flour, 22% tomato passata, 13% firm mozzarella cheese, water, 4.8% Calabrese salami (pork, bacon, salt, dextrose, spices, glucose syrup, spice extracts, antioxidant (rosemary extract), stabilizer (sodium nitrite), smoke), 4.8% cooked pork, seasoned in nduja style (pork, tomato paste, spices, salt, spice extracts), bell peppers, extra virgin olive oil, 1.2% honey, sea salt, yeast, paprika, chili peppers, basil, salt, oregano, garlic, rapeseed oil, lemon juice, chili extract.',
              },
            ],
          },

          {
            '@type': 'Product',

            name: 'Dr. Oetker Suprema - Funghi Ricotta',

            sku: '1-26-618500',

            size: '525 g',

            image:
              'https://www.oetker.de/assets/hygraph/AVtdz8Pl3QxerK0kYX32fz/compress=metadata:true/quality=value:75/output=format:webp/resize=fit:clip,height:662,width:662/cmhtq9svfb6t707w67x5yrjva',

            offers: {
              '@type': 'Offer',

              price: '5.49',

              priceCurrency: 'EUR',

              availability: 'http://schema.org/InStock',

              url: 'https://www.oetker.de/produkte/p/suprema-funghi-ricotta',
            },

            additionalProperty: [
              {
                '@type': 'PropertyValue',

                name: 'Calories',

                value: '1068 kcal',
              },

              {
                '@type': 'PropertyValue',

                name: 'Fat',

                value: '37 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Saturated Fat',

                value: '18 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Carbohydrates',

                value: '136 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Sugars',

                value: '21 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Fiber',

                value: '10 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Protein',

                value: '43 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Sodium',

                value: '5.6 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Vegetarian',

                value: 'Yes',
              },

              {
                '@type': 'PropertyValue',

                name: 'Vegan',

                value: 'No',
              },

              {
                '@type': 'PropertyValue',

                name: 'Gluten-Free',

                value: 'No',
              },

              {
                '@type': 'PropertyValue',

                name: 'Lactose-Free',

                value: 'No',
              },

              {
                '@type': 'PropertyValue',

                name: 'Halal',

                value: 'No',
              },

              {
                '@type': 'PropertyValue',

                name: 'MajorAllergens',

                value: 'wheat flour, cheese, cream',
              },

              {
                '@type': 'PropertyValue',

                name: 'VerifiedDate',

                value: '21.02.2026',
              },

              {
                '@type': 'PropertyValue',

                name: 'Ingredients',

                value:
                  'Wheat flour, 21% tomato passata, 13% cheese (firm mozzarella, smoked cheddar), 11% mushrooms, water, 2.5% ricotta cheese, cream, extra virgin olive oil, sea salt, yeast, 0.3% lemon juice, honey, rosemary.',
              },
            ],
          },

          {
            '@type': 'Product',

            name: 'Dr. Oetker Suprema - Salame Romano',

            sku: '1-26-618100',

            size: '487 g',

            image:
              'https://www.oetker.de/assets/hygraph/AVtdz8Pl3QxerK0kYX32fz/compress=metadata:true/quality=value:75/output=format:webp/resize=fit:clip,height:662,width:662/cmlk0cr1wzzjx07w5bx8sevov',

            offers: {
              '@type': 'Offer',

              price: '5.49',

              priceCurrency: 'EUR',

              availability: 'http://schema.org/InStock',

              url: 'https://www.oetker.de/produkte/p/suprema-salame-romano',
            },

            additionalProperty: [
              {
                '@type': 'PropertyValue',

                name: 'Calories',

                value: '1141 kcal',
              },

              {
                '@type': 'PropertyValue',

                name: 'Fat',

                value: '43 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Saturated Fat',

                value: '20 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Carbohydrates',

                value: '134 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Sugars',

                value: '19 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Fiber',

                value: '9.7 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Protein',

                value: '49 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Sodium',

                value: '6.6 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Vegetarian',

                value: 'No',
              },

              {
                '@type': 'PropertyValue',

                name: 'Vegan',

                value: 'No',
              },

              {
                '@type': 'PropertyValue',

                name: 'Gluten-Free',

                value: 'No',
              },

              {
                '@type': 'PropertyValue',

                name: 'Lactose-Free',

                value: 'Yes',
              },

              {
                '@type': 'PropertyValue',

                name: 'Halal',

                value: 'No',
              },

              {
                '@type': 'PropertyValue',

                name: 'MajorAllergens',

                value: 'wheat flour, cheese',
              },

              {
                '@type': 'PropertyValue',

                name: 'VerifiedDate',

                value: '21.02.2026',
              },

              {
                '@type': 'PropertyValue',

                name: 'Ingredients',

                value:
                  'Wheat flour, 23% tomato passata, 15% firm mozzarella cheese, water, 8.2% salami (pork, bacon, salt, dextrose, spices, spice extracts, antioxidant (rosemary extract), stabilizer (sodium nitrite), smoke), extra virgin olive oil, sea salt, yeast, basil, oregano.',
              },
            ],
          },

          {
            '@type': 'Product',

            name: 'Dr. Oetker Suprema - Margherita',

            sku: '1-26-618000',

            size: '475 g',

            image:
              'https://www.oetker.de/assets/hygraph/AVtdz8Pl3QxerK0kYX32fz/compress=metadata:true/quality=value:75/output=format:webp/resize=fit:clip,height:662,width:662/cmlk0d0x404cs07w1jp4fvz23',

            offers: {
              '@type': 'Offer',

              price: '5.49',

              priceCurrency: 'EUR',

              availability: 'http://schema.org/InStock',

              url: 'https://www.oetker.de/produkte/p/suprema-margherita',
            },

            additionalProperty: [
              {
                '@type': 'PropertyValue',

                name: 'Calories',

                value: '1098 kcal',
              },

              {
                '@type': 'PropertyValue',

                name: 'Fat',

                value: '39 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Saturated Fat',

                value: '19 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Carbohydrates',

                value: '134 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Sugars',

                value: '19 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Fiber',

                value: '9.3 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Protein',

                value: '49 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Sodium',

                value: '5.7 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Vegetarian',

                value: 'No',
              },

              {
                '@type': 'PropertyValue',

                name: 'Vegan',

                value: 'No',
              },

              {
                '@type': 'PropertyValue',

                name: 'Gluten-Free',

                value: 'No',
              },

              {
                '@type': 'PropertyValue',

                name: 'Lactose-Free',

                value: 'Yes',
              },

              {
                '@type': 'PropertyValue',

                name: 'Halal',

                value: 'No',
              },

              {
                '@type': 'PropertyValue',

                name: 'MajorAllergens',

                value: 'wheat flour, cheese',
              },

              {
                '@type': 'PropertyValue',

                name: 'VerifiedDate',

                value: '21.02.2026',
              },

              {
                '@type': 'PropertyValue',

                name: 'Ingredients',

                value:
                  'Wheat flour, 24% tomato passata, 18% firm mozzarella cheese, water, 2.7% Grana Padano hard cheese (milk, salt, animal rennet, lysozyme (egg)), extra virgin olive oil, sea salt, yeast, basil, oregano',
              },
            ],
          },

          {
            '@type': 'Product',

            name: 'Dr. Oetker Suprema - Cinque Formaggi',

            sku: '1-26-618200',

            size: '492 g',

            image:
              'https://www.oetker.de/assets/hygraph/AVtdz8Pl3QxerK0kYX32fz/compress=metadata:true/quality=value:75/output=format:webp/resize=fit:clip,height:662,width:662/cmmo0sqwxgnuv08w3yc0kk6ve',

            offers: {
              '@type': 'Offer',

              price: '5.49',

              priceCurrency: 'EUR',

              availability: 'http://schema.org/InStock',

              url: 'https://www.oetker.de/produkte/p/suprema-cinque-formaggi',
            },

            additionalProperty: [
              {
                '@type': 'PropertyValue',

                name: 'Calories',

                value: '1146 kcal',
              },

              {
                '@type': 'PropertyValue',

                name: 'Fat',

                value: '44 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Saturated Fat',

                value: '23 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Carbohydrates',

                value: '135 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Sugars',

                value: '20 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Fiber',

                value: '9.5 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Protein',

                value: '48 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Sodium',

                value: '6.1 g',
              },

              {
                '@type': 'PropertyValue',

                name: 'Vegetarian',

                value: 'Yes',
              },

              {
                '@type': 'PropertyValue',

                name: 'Vegan',

                value: 'No',
              },

              {
                '@type': 'PropertyValue',

                name: 'Gluten-Free',

                value: 'No',
              },

              {
                '@type': 'PropertyValue',

                name: 'Lactose-Free',

                value: 'No',
              },

              {
                '@type': 'PropertyValue',

                name: 'Halal',

                value: 'No',
              },

              {
                '@type': 'PropertyValue',

                name: 'MajorAllergens',

                value: 'wheat flour, cheese, cream',
              },

              {
                '@type': 'PropertyValue',

                name: 'VerifiedDate',

                value: '31.05.2026',
              },

              {
                '@type': 'PropertyValue',

                name: 'Ingredients',

                value:
                  'Wheat flour, 23% tomato passata, water, 9.1% firm mozzarella cheese, 6.0% smoked cheddar cheese, 4.0% provolone cheese, 2.7% ricotta cheese, cream, extra virgin olive oil, sea salt, yeast, 0.5% blue cheese, basil, salt, oregano',
              },
            ],
          },
        ],
      },

      {
        '@type': 'FAQPage',

        mainEntity: [
          {
            '@type': 'Question',

            name: 'What is the correct baking method for Dr. Oetker Suprema Pizza?',

            acceptedAnswer: {
              '@type': 'Answer',

              text: 'Baking instructions for Dr. Oetker Suprema are: Preheat your oven to 220°C (top/bottom heat). Remove all packaging. While the oven is heating, let the pizza reach room temperature. Place the pizza directly on the bottom wire rack of your oven. Bake for 11–14 minutes.',
            },
          },

          {
            '@type': 'Question',

            name: 'What oven temperature and baking time are recommended?',

            acceptedAnswer: {
              '@type': 'Answer',

              text: '220°C (top/bottom heat) and a baking time of 11–14 minutes.',
            },
          },

          {
            '@type': 'Question',

            name: 'Does Dr. Oetker Suprema Pizza require preheating the oven?',

            acceptedAnswer: {
              '@type': 'Answer',

              text: 'Yes, preheating is required for optimal crispy and airy baking results.',
            },
          },

          {
            '@type': 'Question',

            name: 'Can Dr. Oetker Suprema Pizza be prepared in an air fryer?',

            acceptedAnswer: {
              '@type': 'Answer',

              text: 'Dr. Oetker Suprema is a large pizza and will not fit into most standard air fryers.',
            },
          },

          {
            '@type': 'Question',

            name: 'How does Dr. Oetker Suprema Pizza taste compared to thin-crust frozen pizzas?',

            acceptedAnswer: {
              '@type': 'Answer',

              text: 'Dr. Oetker Suprema features a very thin, crispy base and a high-risen crust that is crispy on the outside and light and airy on the inside. It offers a more premium, artisanal pizza experience compared to regular thin-crust frozen pizzas.',
            },
          },

          {
            '@type': 'Question',

            name: 'What texture does Dr. Oetker Suprema Pizza have after baking?',

            acceptedAnswer: {
              '@type': 'Answer',

              text: 'It has a very thin and crispy base with a high-risen edge that is crispy on the outside and soft and airy on the inside.',
            },
          },

          {
            '@type': 'Question',

            name: 'Is Dr. Oetker Suprema Pizza part of a specific product line?',

            acceptedAnswer: {
              '@type': 'Answer',

              text: 'Yes, it is a premium frozen pizza range with inspiration from Neapolitan-style pizza.',
            },
          },

          {
            '@type': 'Question',

            name: 'What is the serving size of one Dr. Oetker Suprema Pizza?',

            acceptedAnswer: {
              '@type': 'Answer',

              text: 'One pizza is typically considered one serving. Due to its size, it can also be shared for a lighter meal.',
            },
          },

          {
            '@type': 'Question',

            name: 'How long does Dr. Oetker Suprema Pizza need to bake?',

            acceptedAnswer: {
              '@type': 'Answer',

              text: '11–14 minutes at 220°C after preheating and allowing the pizza to reach room temperature.',
            },
          },

          {
            '@type': 'Question',

            name: 'Should Dr. Oetker Suprema Pizza be cooked from frozen?',

            acceptedAnswer: {
              '@type': 'Answer',

              text: 'Yes. Follow the official instructions: preheat oven to 220°C, remove packaging, allow the pizza to temper during preheating, then bake for 11–14 minutes.',
            },
          },

          {
            '@type': 'Question',

            name: 'Is Dr. Oetker Suprema Pizza vegetarian?',

            acceptedAnswer: {
              '@type': 'Answer',

              text: 'Some variants are vegetarian like Dr. Oetker Suprema - Funghi Ricotta and Dr. Oetker Suprema - Cinque Formaggi, while the others contain meat.',
            },
          },
        ],
      },

      {
        '@type': 'PropertyValue',

        name: 'DisambiguationEntities',

        value: [
          'Dr. Oetker Ristorante Pizza is a classic frozen pizza by Dr. Oetker with a thin crust and belongs to a different product line than Suprema.',

          'Dr. Oetker Tradizionale Pizza is a rustic-style frozen pizza with a thicker and airy crust and a different dough structure and positioning.',

          'Dr. Oetker Die Ofenfrische Pizza is a raw-dough frozen pizza system with an airy inside and crispy outside and a different baking concept.',

          'Wagner Stone Oven Pizza is a frozen pizza brand from Wagner with a different manufacturer and recipe.',

          'Gustavo Gusto Frozen Pizza is an independent German premium frozen pizza brand with separate positioning and quality standards.',

          'Private Label Frozen Pizzas are supermarket own-brand frozen pizzas with different manufacturers, recipes, and price positioning.',
        ],
      },
    ],
  };
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
};
